import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import styles from './werdeTeilVonUns.module.css'
import { useNavigate } from "react-router-dom";
import * as r from "../../../config/references_files";
function WerdeTeilVonUns() {
    const [isOpenBetreuungskraft, setIsOpenBetreuungskraft] = useState(false);
    const [isOpenFSJ, setIsOpenFSJ] = useState(false);
    const [isOpenUebungsleiter, setIsOpenUebungsleiter] = useState(false);
    const [IsOpenInitiativbewerbung, setIsOpenInitiativbewerbung] = useState(false);
    const navigate = useNavigate();

    const closeAll = () => {
        // fitness und entspannung
        setIsOpenBetreuungskraft(false);
        setIsOpenFSJ(false);
        setIsOpenUebungsleiter(false);
        setIsOpenInitiativbewerbung(false);
    };

    function useIsBelow800(breakpoint = 800) {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < breakpoint);
            };
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, [breakpoint]);

        return isMobile;
    }
    function useIsBelow500(breakpoint = 500) {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < breakpoint);
            };
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, [breakpoint]);

        return isMobile;
    }
    const isBelow800 = useIsBelow800();
    const isBelow500 = useIsBelow500();
    const location = useLocation();
    useEffect(() => {
        // Reset all states
        closeAll();

        // Check hash and update corresponding state
        switch (location.hash.replace("#", "")) {
            case "betreuungskraft":
                setIsOpenBetreuungskraft(true);
                break;
            case "fsj":
                setIsOpenFSJ(true);
                break;
            case "uebungsleiter-in":
                setIsOpenUebungsleiter(true);
                break;
            case "initiativbewerbung":
                setIsOpenInitiativbewerbung(true);
                break;
            default:
                break;
        }
    }, [location.hash]);

    return (
        <section className={styles.container}>
            <h1>Werde Teil von Uns!</h1>
            <section className={styles.chapter}>
                <h2 id='mitgliedschaft-oder-flexkarte'>Mitgliedschaft oder doch eine Flexkarte?</h2>
                <p>Der TuS bietet zwei verschiedene Wege um beim <span onClick={() => navigate("/erlebnissport")}>Sportangebot</span> mitzumachen:</p>
                <div className={styles.list}>
                    <div className={styles.listItem}>
                        <div className={styles.listCategory}>
                            <p className={styles.listTitle}>1. Mitgliedschaft:</p>
                        </div>
                        <div className={styles.listText}>
                            <ul>
                                <li>Unterstützung des Vereinswesens</li>
                                <li>4 Kategorien: Kinder & Jugendliche | Erwachsene | Familie | Inaktives Mitglied</li>
                                <li>verschiedene Kurse unserer Sportangebote</li>
                                <li>kostengünstige oder kostenfreie Teilnahme an Events (z.B. Sportfest, Workshops)</li>
                                <li>das ein oder andere "Mitgebsel" wie z.B. "2 für 1 Saunabesuch"</li>
                                <li>Alle Mitglieder sind bei allen sportlichen Aktivitäten und auf allen Wegen zum Sport über den TuS versichert (ARAG-Landessportbund)</li>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.listItem}>
                        <div className={styles.listCategory}>
                            <p className={styles.listTitle}>2. Flexkarte:</p>
                        </div>
                        <div className={styles.listText}>
                            <ul>
                                <li>Nutzung unserer Sportangebote unter den jeweiligen Konditionen</li>
                                <li>Für Mitglieder: Flexkarte 50</li>
                                <li>Für Nicht-Mitglieder: Flexkarte 100 & Flexkarte 150</li>
                                <li>Mehr Flexibilität im Alltag</li>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.listItem}>
                        <div className={styles.listCategory}>
                            <p className={styles.listTitle}>Schnupperstunde:</p>
                        </div>
                        <div className={styles.listText}>
                            <ul>
                                <li>Die Teilnahme an der ersten Stunde ist kostenfrei</li>
                                <li>Bei weiterer Teilnahme soll nach spätestens 14 Tagen beim Übungsleiter oder der Geschäftstelle ein Antrag auf Mitgliedschaft oder Kursteilnahme gestellt werden.</li>
                                <li>Mehr Flexibilität im Alltag</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section className={styles.chapter}>
                <h2 id='kosten'>Kosten</h2>
                <table className={styles.table}>
                    <thead className={styles.thead1}>
                        <tr>
                            <td >Mitgliedschaft</td>
                            <td>{isBelow800 ? "Monat" : "Monatsbeitrag"}</td>
                            <td>{isBelow800 ? "Jahr" : "Jahresbeitrag"}</td>
                            <td >Info</td>
                        </tr>
                    </thead>
                    <tbody className={styles.tbody1}>
                        <tr className={styles.kinder}>
                            <td>{isBelow800 ? "Unter 18 Jährige:" : " Kinder und Jugendliche ( < 18 Jahre):"}</td>

                            <td >11,67€</td>
                            <td >140,00€</td>
                            <td>alle Abteilungen (- Talentwerk)</td>
                        </tr>
                        <tr >
                            <td>{isBelow800 ? "Mitgl. inkl. Talentwerk:" : "Mitgliedschaft inkl. Talentwerk:"}</td>

                            <td>36,67€</td>
                            <td>440,00€</td>
                            <td>alle Abteilungen (+ Talentwerk)</td>
                        </tr>
                        <tr className={styles.erwachsene}>
                            <td >Erwachsene:</td>
                            <td>15,50€</td>
                            <td>186,00€</td>
                            <td></td>
                        </tr>
                        <tr className={styles.familie}>
                            <td >Familien:</td>
                            <td>29,00€</td>
                            <td>348,00€</td>
                            <td>zwei Erwachsenen + alle Kinder</td>
                        </tr>
                        <tr className={styles.inaktiv}>
                            <td >Inaktives Mitglied:</td>
                            <td>5,50€</td>
                            <td>66,00€</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>{isBelow800 ? "Förderv. des Jugendfu. - Einzel:" : "Förderverein des Jugendfußballs - Einzel:"}</td>

                            <td>3,00€</td>
                            <td>36,00€</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>{isBelow800 ? "Förderv. des Jugendfu. - Familie:" : "Förderverein des Jugendfußballs - Familie:"}</td>

                            <td>5,00€</td>
                            <td>60,00€</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <div className={styles.hinweis}>
                    <p><strong>Hinweis:</strong> Bei jeder "aktiven" Mitgliedschaft können für bestimmte Kurse "Plus-Beiträge" anfallen.</p>
                </div>
                <table className={styles.table}>
                    <thead className={styles.thead2}>
                        <tr>

                            <td>{isBelow500 ? "Flex-karte" : "Flexkarte"}</td>
                            <td>{isBelow500 ? "Ein-heiten" : "Einheiten"}</td>
                            <td >Preis / Einheit</td>
                            <td>{isBelow500 ? "Karten-preis" : "Kartenpreis"}</td>
                            <td >Info</td>
                        </tr>
                    </thead>
                    <tbody className={styles.tbody2}>
                        <tr className={styles.dick}>
                            <td>Flexkarte <span className={styles.flexkarteNumber}>50</span>:</td>
                            <td >10</td>
                            <td >5,00€</td>
                            <td>50,00€</td>
                            <td>für Vereinsmitglieder</td>
                        </tr>
                        <tr className={styles.dick}>
                            <td >Flexkarte 100:</td>
                            <td>10</td>
                            <td>10,00€</td>
                            <td>100,00€</td>
                            <td>Einheiten je 1 Stunde</td>
                        </tr>
                        <tr className={styles.dick}>
                            <td >Flexkarte 150:</td>
                            <td>10</td>
                            <td>15,00€</td>
                            <td>150,00€</td>
                            <td>Einheiten 1,5 oder 2 Stunden</td>
                        </tr>
                    </tbody>
                </table>
                <table className={styles.table}>
                    <thead className={styles.thead2}>
                        <tr>

                            <td>{isBelow500 ? "Flex-karte" : "Flexkarte"}</td>
                            <td>{isBelow500 ? "Ein-heiten" : "Einheiten"}</td>
                            <td >Preis / Einheit</td>
                            <td>{isBelow500 ? "Karten-preis" : "Kartenpreis"}</td>
                            <td >Info</td>
                        </tr>
                    </thead>
                    <tbody className={styles.tbody2}>
                        <tr className={styles.dick}>
                            <td >Flexkarte Reha <span className={styles.flexkarteNumber}>75</span>:</td>
                            <td >10</td>
                            <td >7,50€</td>
                            <td>75,00€</td>
                            <td>Aqua-Reha ist nur ärztlich verordnet möglich</td>
                        </tr>
                        <tr className={styles.dick}>
                            <td >Flexkarte Reha 100:</td>
                            <td>10</td>
                            <td>10,00€</td>
                            <td>100,00€</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <section className={styles.chapter}>
                <h2 id='anmeldung'>Anmeldung</h2>
                <ul>
                    <li>
                        Um Mitglied zu werden folgen Sie bitte diesem Online-Formular: <span onClick={() => navigate(r.mitgliedantragTuS)}>Mitgliedsantrag stellen</span>.
                    </li>
                    <li>Flex- bzw. Kurskarten können entweder direkt beim Übungsleiter (nur Barzahlung) oder während der Geschäftszeiten in der Geschäftsstelle (Bar- oder EC-Zahlung) erworben werden.
                    </li>
                </ul>
            </section>
            <section className={styles.chapter}>
                <h2 id='ehrenamt'>Ehrenamt</h2>
                <div className={styles.ehrenamt}>
                    <p>Ohne ehrenamtliches Engagement können die Vereine die Türen schließen! Damit würde nicht nur der organisierte Sport wegbrechen, sondern es würden viele wichtige gesellschaftliche und soziale Aufgaben nicht mehr erfüllt.
                        Leidtragende wären wir alle, insbesondere aber die Kinder, Jugendlichen und ältere Menschen.</p>
                    <div>
                        <p>Der TuS bietet ein spannendes Sportangebot und engagiert sich darüber hinaus in vielen weiteren Feldern z. B.:</p>
                        <ul>
                            <li>in den Offenen Ganztagsschulen</li>
                            <li>im Rehabilitationssport</li>
                            <li>oder über das Hilfsprojekt „Obstkäppchen“, das ältere und oft einsame Menschen unterstützt.</li>
                        </ul>
                    </div>
                    <p>Ein dauerhaftes Engagement, z. B. als Übungsleiter oder in der Vereinsorganisation, hilft genauso wie punktuelle Einsätze im Rahmen von Projekten und Events.</p>
                    <p>Wir freuen uns sehr über jede Form der ehrenamtlichen Unterstützung. Melden Sie sich gerne per E-Mail oder telefonisch bei uns.</p>
                    <div className={styles.emailContainer}>
                        <p>E-Mail: <span onClick={() => (window.location.href = 'mailto:geschaeftsstelle@tus05-oberpleis.de')} style={{ cursor: "pointer" }}>geschaeftsstelle@tus05-oberpleis.de</span></p>
                        <p>Telefon: <span onClick={() => (window.location.href = 'tel:022449020117')} style={{ cursor: "pointer" }}>02244 / 9020117</span></p>
                    </div>
                </div>

            </section>
            <section className={styles.chapter}>
                <h2 id='schiedsrichter-in'>Schiedsrichter:in</h2>
                <div className={styles.schiedsrichterWrapper}>
                    <div className={styles.schiedsrichterContainer}>
                        <img className={styles.img} src={`${process.env.PUBLIC_URL}/images/personen/tobiasEsch.jpg`}
                            alt="Tobias Esch" />
                        <div className={styles.schiedsrichterText}>
                            <p><strong>Du möchtest Schiedsrichterin oder Schiedsrichter werden?</strong></p>
                            <p>Mit Tobias Esch hat der TuS einen der aufstrebensten Schiedsrichtertalente im aktuellen Fußballbereich. Mit nur 20 Jahren hat dieser im Jahr 2022 den Sprung in die Regionalliga geschafft.</p>
                            <p>Möchtest du mehr über Tobias und sein Werdegang erfahren, schau dir gerne dieses Interview zwischen Richard Lemke und ihm hier an.</p>
                            <div>
                                <p>Um in Tobias Fußstampfen zu treten musst du bei uns folgende Bedingungen erfüllen:</p>
                                <ul>
                                    <li>Du bist mindestens 12 Jahre alt</li>
                                    <li>bist selbstbewusst und hast eine gute Menschenkenntnis</li>
                                    <li>hast Mut Verantwortung zu übernehmen</li>
                                    <li>bist zuverlässig, belastbar und fit.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <p>Darüber hinaus beherrschst du die deutsche Sprache in Wort und Schrift und hast Lust und Zeit an den verpflichtenden Aus- und Weiterbildungsmaßnahmen teilzunehmen.</p>
                    <p>Dann melde dich doch gerne bei uns per E-Mail oder telefonisch.</p>
                    <div className={styles.emailContainer}>
                        <p>E-Mail: <span onClick={() => (window.location.href = 'mailto:geschaeftsstelle@tus05-oberpleis.de')} style={{ cursor: "pointer" }}>geschaeftsstelle@tus05-oberpleis.de</span></p>
                        <p>Telefon: <span onClick={() => (window.location.href = 'tel:022449020117')} style={{ cursor: "pointer" }}>02244 / 9020117</span></p>
                    </div>
                </div>
            </section>
            <section className={styles.chapter}>
                <h2 id='jugendfoerderverein'>Der Jugendförderverein des TuS 05 Oberpleis</h2>
                <div className={styles.foerderverein}>

                    <img src="/uploads/images/basaltarena.jpg"></img>
                    <p>Starke Unterstützung für engagierten Jugendsport</p>
                </div>
                <section>
                    <h4>Unser Ziel</h4>
                    <p>Der Jugendförderverein des TuS 05 Oberpleis setzt sich mit Herzblut für die materielle und ideelle Förderung des Jugendsports ein. Wir unterstützen gezielt die Jugendmannschaften des Vereins und machen uns stark für sozial benachteiligte Spieler*innen sowie für Jugendliche in besonderen Lebenslagen – ganz gleich, aus welchem Land sie kommen.</p>
                </section>
                <section>
                    <h4>Unsere Bedeutung</h4>
                    <p>Unser Förderverein ist die zentrale Anlaufstelle, um jedem jungen Menschen die Teilnahme am Trainings- und Spielbetrieb sowie an sämtlichen Mannschaftsevents zu ermöglichen – unabhängig von den persönlichen oder finanziellen Voraussetzungen. Wir sorgen durch unsere Unterstützung dafür, dass wirklich alle Jugendlichen Teil des Vereinslebens werden können. Mit gezielten Fördermaßnahmen wird die Trainingsausstattung kontinuierlich modernisiert: Von neuen Bällen, Hütchen, Hemdchen, Minitoren bis zu Tornetzen und Materialien für Trainer*innen und Offizielle. So schaffen wir gemeinsam ein Umfeld, das Chancengleichheit fördert und Teilhabe für alle ermöglicht.</p>
                </section>
                <section>
                    <h4>Unser Fianzierung</h4>
                    <p>Um all diese Maßnahmen zu ermöglichen, setzen wir auf die Beiträge unserer Mitglieder, Spenden sowie auf Einnahmen aus besonderen Veranstaltungen, seien es sportliche oder gesellschaftliche Events. So schaffen wir gemeinsam ein starkes Fundament für den Nachwuchs und die Zukunft des TuS 05 Oberpleis.</p>
                </section>
                <section>
                    <h4>Was haben wir bisher erreicht?</h4>
                    <p>In den letzten Jahren konnten wir bereits eine Vielzahl konkreter Verbesserungen und Unterstützungsleistungen umsetzen. Neben der Übernahme oder Unterstützung von Mitgliedsbeiträgen für Kinder haben wir gezielt Kindern die Teilnahme an Fahrten zu Turnieren nach Barcelona sowie ins Trainingslager nach Reken ermöglicht. Über den Förderverein wurden allein in den vergangenen zwei Jahren mehr als 180 Trainingsbälle, 6 Minitore und zahlreiche weitere Trainingsmaterialien angeschafft. Auch die gesamte aktuelle Ausstattung unserer Trainer*innen wurde durch unseren Verein bereitgestellt – so schaffen wir gemeinsam beste Voraussetzungen für sportlichen Erfolg und Teamgeist.</p>
                </section>
                <section>
                    <h4>Sei dabei!</h4>
                    <p>Wir laden alle ein, Teil des Jugendfördervereins zu werden, um die Begeisterung, das Miteinander und die Entwicklung junger Menschen im Sport nachhaltig zu fördern.</p>
                    <p><strong>Werde Förderer des Jugendabteilung:</strong> <a href={r.mitgliedantragJugendfoerderverein}>Mitgliedsantrag</a></p>
                    <p>Unserer Satung kann hier gefunden werden: <a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/JFV_satzung_03_2014.pdf`} target="_blank" rel="noopener noreferrer">Satzung Jugendförderverein</a></p>
                </section>
            </section>
            <section className={styles.chapter}>
                <h2 id='stellenausschreibungen'>Stellenausschreibungen</h2>
                <div className={styles.SAWrapper}>
                    <div id="betreuungskraft" className={styles.card}>
                        <div className={styles.title} onClick={() => setIsOpenBetreuungskraft(!isOpenBetreuungskraft)}>
                            <p className={styles.name}>Betreuungskraft (M/W/D) für den Standort Oberpleis (OGS)</p>
                            <svg className={`${styles.gt} ${isOpenBetreuungskraft ? styles.rotated : ""}`} style={{ cursor: "pointer" }} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.28 122.88" >
                                <title>greater-than</title>
                                <polygon points="0 122.88 103.28 76.93 103.28 45.95 0 0 0 33.94 75.46 61.34 0 88.74 0 122.88 0 122.88" />
                            </svg>
                        </div>
                        <div className={`${styles.cardContent} ${isOpenBetreuungskraft ? styles.show : styles.hide}`}>
                            <div className={styles.modulContainer}>
                                <div className={styles.mainModul}>
                                    <p>Der TuS 1905 Oberpleis e.V. ist Träger der Offenen Ganztagsschule in Königswinter-Oberpleis mit einem Außenstandort in Eudenbach.<br />Zurzeit betreuen wir an beiden Standorten der Grundschule Sonnenhügel ca. 250 Kinder.</p>
                                    <p>Für den Standort Oberpleis suchen wir derzeit Betreungsskräfte (m/w/d).</p>
                                    <div className={styles.list}>
                                        <p>Zu ihren Tätigkeiten gehören:</p>
                                        <ul>
                                            <li>Gemeinsames Mittagessen mit einer festen Kindergruppe, Lernzeitbetreuung, Durchführung von Betreuungsangeboten im Nachmittagsbereich</li>
                                            <li>Kreative Freispielgestaltung</li>
                                            <li>Ausbau und Begleitung von Angeboten in der OGS</li>
                                            <li>Begleitung von (Klein-) Gruppen</li>
                                            <li>Betreuung von Ferienangeboten</li>
                                            <li>Teilnahme an Teamsitzungen</li>
                                            <li>Vertrauensvolle Zusammenarbeit mit dem Träger</li>
                                        </ul>
                                    </div>
                                    <div className={styles.list}>
                                        <p>Ihr Profil:</p>
                                        <ul>
                                            <li>Sie haben Spaß an der Arbeit mit Kindern</li>
                                            <li>Wünschenswert wären berufliche Vorerfahrungen in der Arbeit mit Kindern</li>
                                            <li>Sie sind körperlich belastbar und flexibel</li>
                                            <li>Wichtig wären soziale und kommunikative Kompetenzen, Teamgeist und Offenheit</li>
                                        </ul>
                                    </div>
                                    <div className={styles.list}>
                                        <p>Wir bieten Ihnen:</p>
                                        <ul>
                                            <li>Eine spannende Aufgabe in einem netten und offenen Team</li>
                                            <li>Ein wertschätzendes Miteinander</li>
                                            <li>Zielgerichtete Fortbildungsangebote</li>
                                        </ul>
                                    </div>
                                    <p>Der TuS 1905 Oberpleis e. V. begrüßt die Gleichstellung aller Menschen und freut sich deshalb über Bewerbungen von Frauen und Männern, unabhängig von deren ethnischer, kultureller oder sozialer Herkunft, Alter, Behinderung oder sexueller Identität ausdrücklich.</p>
                                    <p>Wenn Sie an dieser spannenden und abwechslungsreichen Aufgabe interessiert sind, richten Sie Ihre vollständigen Bewerbungsunterlagen und Ihren frühest-möglichen Einstiegstermin an die nachstehende Adresse:</p>
                                    <div className={styles.adress}>
                                        <p>OGS Oberpleis, TuS 1905 Oberpleis e.V.</p>
                                        <p>Frau Neußer (päd. Leitung) / Herr Weber (Geschäftsführer)</p>
                                        <p>Humboldtstr. 3a, 53639 Königswinter</p>
                                        <p>Telefon: 02244 / 9020117</p>
                                        <p>E-Mail: <span>ogs@tus05-oberpleis.de</span></p>
                                    </div>
                                    <a href={r.stellenanzeige} target="_blank" rel="noopener noreferrer">Stellenausschreibung: Betreuungskraft (PDF-Version)</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="fsj" className={styles.card}>
                        <div className={styles.title} onClick={() => setIsOpenFSJ(!isOpenFSJ)}>
                            <p className={styles.name}>Freiwilliges Soziales Jahr (FSJ) (M/W/D)</p>
                            <svg className={`${styles.gt} ${isOpenFSJ ? styles.rotated : ""}`} style={{ cursor: "pointer" }} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.28 122.88" >
                                <title>greater-than</title>
                                <polygon points="0 122.88 103.28 76.93 103.28 45.95 0 0 0 33.94 75.46 61.34 0 88.74 0 122.88 0 122.88" />
                            </svg>
                        </div>
                        <div className={`${styles.cardContent} ${isOpenFSJ ? styles.show : styles.hide}`}>
                            <div className={styles.modulContainer}>
                                <div className={styles.mainModul}>
                                    <p>Das Freiwillige Soziale Jahr (FSJ) ist ein Freiwilligendienst in sozialen Bereichen. Er wird in Deutschland für Jugendliche und junge Erwachsene angeboten, die die Vollzeitschulpflicht bereits erfüllt haben und das 27. Lebensjahr noch nicht vollendet haben. Die Rahmenbedingungen für das FSJ sind im Jugendfreiwilligendienstegesetz verankert.</p>
                                    <p>Der TuS bietet <strong>Einsatzmöglichkeiten im Sportbereich sowie den Offenen Ganztagsschulen</strong> am Ölberg (Gymnasium Oberpleis) und am Sonnenhügel (Einsatzstellen Oberpleis bzw. Eudenbach) an. </p>
                                    <div className={styles.list}>
                                        <p>Unsere FSJler sind fest ins Schul- und Vereinsleben integriert:</p>
                                        <ul>
                                            <li>Sie betreuen die Kinder,</li>
                                            <li>unterstützen bei den Hausaufgaben,</li>
                                            <li>leiten AGs,</li>
                                            <li>Freispiel- und Übungseinheiten</li>
                                            <li>sind als Jugendtrainer im Einsatz</li>
                                            <li>und führen selbstständig spannende Projekte durch</li>
                                        </ul>
                                    </div>
                                    <p>Im Rahmen regelmäßig stattfindender Seminartage werden sie für die vielfältigen Aufgaben <strong>pädagogisch geschult und erwerben Übungsleiterlizenzen</strong>.<br />as FSJ wird über den Landessportbund Nordrhein-Westfalen (LSB NRW) organisiert.</p>
                                    <p>Wer sich bewerben möchte oder Fragen hat, melde sich bitte per Mail an <span onClick={() => (window.location.href = 'mailto:geschaeftsstelle@tus05-oberpleis.de')} style={{ cursor: "pointer" }}>geschaeftsstelle@tus05-oberpleis.de</span> oder telefonisch unter <span onClick={() => (window.location.href = 'tel:022449020117')} style={{ cursor: "pointer" }}>02244 / 9020117</span>.</p>
                                    {/* <a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/BeispielPDF.pdf`} target="_blank" rel="noopener noreferrer">Stellenausschreibung: FSJler:innen (PDF-Version)</a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="uebungsleiter-in" className={styles.card}>
                        <div className={styles.title} onClick={() => setIsOpenUebungsleiter(!isOpenUebungsleiter)}>
                            <p className={styles.name}>Übungsleiter:in im Jugendbereich Fußball</p>
                            <svg className={`${styles.gt} ${isOpenUebungsleiter ? styles.rotated : ""}`} style={{ cursor: "pointer" }} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.28 122.88" >
                                <title>greater-than</title>
                                <polygon points="0 122.88 103.28 76.93 103.28 45.95 0 0 0 33.94 75.46 61.34 0 88.74 0 122.88 0 122.88" />
                            </svg>
                        </div>
                        <div className={`${styles.cardContent} ${isOpenUebungsleiter ? styles.show : styles.hide}`}>
                            <div className={styles.modulContainer}>
                                <div className={styles.mainModul}>
                                    <p><strong>Der TuS sucht Übungsleiter im Jugendbereich!</strong></p>
                                    <p>Bei uns arbeitest du in einem freundlichen und hilfsbereiten Trainerumfeld. Ein enger Kontakt zum Jugendvorstand ist für uns selbstverständlich.</p>
                                    <p>Außerdem bieten wir dir zahlreiche Fortbildungsmöglichkeiten sowie moderne Trainingsstätten.</p>
                                    <p>Wenn du jetzt Lust bekommen hast unser Trainerteam zu unterstützen, dann melde dich bei uns!</p>
                                    <p>Ansprechpartner ist unser Jugendleiter Patrick Rüth: <span onClick={() => (window.location.href = 'mailto:p.rueth@tus05-oberpleis.de')} style={{ cursor: "pointer" }}>p.rueth@tus05-oberpleis.de</span> oder <span onClick={() => (window.location.href = 'tel:015753307979')} style={{ cursor: "pointer" }}>01575 / 3307979</span>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="initiativbewerbung" className={styles.card}>
                        <div className={styles.title} onClick={() => setIsOpenInitiativbewerbung(!IsOpenInitiativbewerbung)}>
                            <p className={styles.name}>Initiativbewerbung</p>
                            <svg className={`${styles.gt} ${IsOpenInitiativbewerbung ? styles.rotated : ""}`} style={{ cursor: "pointer" }} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.28 122.88" >
                                <title>greater-than</title>
                                <polygon points="0 122.88 103.28 76.93 103.28 45.95 0 0 0 33.94 75.46 61.34 0 88.74 0 122.88 0 122.88" />
                            </svg>
                        </div>
                        <div className={`${styles.cardContent} ${IsOpenInitiativbewerbung ? styles.show : styles.hide}`}>
                            <div className={styles.modulContainer}>
                                <div className={styles.mainModul}>
                                    <p>Wir freuen uns über Ihre Initiativbewerbung, wenn Sie Teil des Teams der Offenen Ganztagsschulen am Sonnenhügel (Grundschule) oder am Ölberg (Gymnasium) werden möchten. Senden Sie uns dazu bitte ein Motivationsschreiben und Ihren Lebenslauf an <span onClick={() => (window.location.href = 'mailto:ogs@tus05-oberpleis.de')} style={{ cursor: "pointer" }}>ogs@tus05-oberpleis.de</span> zu!</p>
                                    <p>Darüber hinaus suchen wir regelmäßig Unterstützung für unsere Sportabteilungen: Melden Sie sich bitte, wenn Sie uns zum Beispiel als Trainer, Übungsleiter, Scout, Schiedsrichter oder ehrenamtlicher Helfer unterstützen möchten. Senden Sie uns eine entsprechende Mail an <span onClick={() => (window.location.href = 'mailto:geschaeftsstelle@tus05-oberpleis.de')} style={{ cursor: "pointer" }}>geschaeftsstelle@tus05-oberpleis.de</span> oder melden Sie sich telefonisch unter <span onClick={() => (window.location.href = 'tel:022449020117')} style={{ cursor: "pointer" }}>02244 – 9020117</span>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    )

}

export default WerdeTeilVonUns;